import { defineComponent as _defineComponent } from 'vue'
import '@patsnap-ui/icon/assets/solid/move.svg';
import '@patsnap-ui/icon/assets/solid/ArrowsmallDown.svg';
import '@patsnap-ui/icon/assets/solid/ArrowLeft.svg';
import '@patsnap-ui/icon/assets/solid/ArrowRight.svg';

import { Icon as PzIcon } from 'patsnap-biz';
import { Tooltip } from 'element-ui';
import type { FieldEditorService } from './index';
import CommentsList from './comments/CommentsList.vue';
import _ from 'lodash';
import { computed, nextTick, onBeforeUnmount, onMounted, provide, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldEditor',
  props: {
    service: null
  },
  setup(__props: any) {

const props = __props as {
    service: FieldEditorService;
}

const ElTooltip = Tooltip;

const comp = computed(() => {
    const type = fieldEditorService.value.field?.field_type;
    if (type === 'LAYER') {
        return () => import('./LayerEditor.vue')
    }
    else if (type === 'OPTION') {
        return () => import('./OptionEditor.vue')
    }
    return type;
})



const fieldEditorService = computed(() => props.service);

provide('fieldEditorService', fieldEditorService);

function handleDrag(event: MouseEvent) {
    fieldEditorService.value.dragEditor(event);
}

function handleResize() {
    fieldEditorService.value.resizeEditor();
}

function handleChange(data: any) {
    fieldEditorService.value.setNewValue(data, true);
}

watch(() => fieldEditorService.value.voteStatus.enabled, () => {
    if (fieldEditorService.value.voteStatus.enabled) {
        fieldEditorService.value.updateVoteCommentsInfo();
    }
},{ immediate: true });

let $backDrop: HTMLElement | undefined = undefined;

function onClickOutside() {
    fieldEditorService.value.hide();
}

onMounted(() => {
    if (fieldEditorService.value.draggableDialogMode) {
        nextTick(() => {
            $backDrop = document.createElement('div');
            $backDrop.className = 'field-editor__backdrop';
            document.body.insertBefore($backDrop, document.body.firstChild);
            $backDrop.onclick = () => {
                onClickOutside()
            }
        })
    } else {
        fieldEditorService.value.setEditor(fieldEditorService.value.isShowComments);
    }
    fieldEditorService.value.initEditorRect();
});

onBeforeUnmount(() => {
    $backDrop?.remove();
    fieldEditorService.value.filterWords = '';
});

return { __sfc: true,ElTooltip, comp, props, fieldEditorService, handleDrag, handleResize, handleChange, $backDrop, onClickOutside, PzIcon, CommentsList }
}

})